import React, { useEffect } from 'react';
import {
    Box,
    Typography,
    Container,
    Divider,
    useTheme,
    useMediaQuery
} from '@mui/material';
import './Datenschutzhinweise.css'; // Import the CSS file
import Navbar from "../Navbar/Nabvar";
import Footer from "../Footer/Footer";

const Datenschutzerklaerung = () => {
    const primaryBlue = '#1F1B9E';
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isTablet = useMediaQuery(theme.breakpoints.down('md'));

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const contentBoxStyle = {
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        borderRadius: 4,
        p: { xs: 2, sm: 3, md: 4 },
        mb: { xs: 2, sm: 3, md: 4 },
        boxShadow: theme.shadows[3],
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            background: `linear-gradient(to bottom right,
                rgba(240, 245, 255, 0.9),
                rgba(230, 240, 255, 0.9))`
        }}>
            <Navbar />

            <Container maxWidth="md" sx={{
                py: { xs: 4, sm: 6, md: 8 },
                px: { xs: 2, sm: 3, md: 4 },
                flex: 1
            }}>
                <Box sx={{ textAlign: 'center', mb: { xs: 3, sm: 4, md: 6 } }}>
                    <Typography
                        variant="h1"
                        sx={{
                            color: primaryBlue,
                            fontSize: { xs: '1.8rem', sm: '2.2rem', md: '2.5rem' },
                            fontWeight: 'bold',
                            textTransform: 'uppercase',
                            marginTop: '30px'
                        }}
                    >
                        Datenschutzerklärung
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography variant="body1" paragraph className="justified-text">
                        Der Schutz Ihrer personenbezogenen Daten ist uns ein besonderes Anliegen. Hier können Sie sich einfach und schnell einen Überblick verschaffen, welche personenbezogenen Daten wir von Ihnen erheben und was wir damit machen.
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.5rem', sm: '1.7rem', md: '1.9rem' }
                        }}
                    >
                        Datenerhebung, Zweck & Rechtsgrundlage
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Wir, die CAMPUS 02 – Fachhochschule der Wirtschaft GmbH (kurz FH CAMPUS 02), Körblergasse 126, 8010 Graz, verarbeiten bei Ihrem Besuch dieses Webauftritts automationsunterstützt folgende Serverlogdaten:
                    </Typography>
                    <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                        <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                            Datum und Uhrzeit der Anfrage
                        </Typography>
                        <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                            IP-Adresse des Clients sowie geographische Länge und Breite der IP-Adresse
                        </Typography>
                        <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                            Land des Nutzers*der Nutzerin
                        </Typography>
                        <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                            User-Agent-String: enthält Informationen über den Browser und das Betriebssystem des Nutzers*der Nutzerin
                        </Typography>
                        <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                            Referer-URL: kann Informationen darüber enthalten, von welcher Seite der Nutzer*die Nutzerin gekommen ist
                        </Typography>
                    </Box>
                    <Typography variant="body1" paragraph className="justified-text">
                        Die Verarbeitung bzw. Speicherung der genannten Daten dient dem Zweck, den Webauftritt sicherzustellen und funktionsfähig zu halten. Dies umfasst vor allem die rasche Identifizierung und Behebung von Fehlern und Sicherheitslücken/-gefahren und das Monitoring der Serverleistung. Die Verarbeitung bezweckt zudem die Weiterentwicklung und Qualitätssteigerung der Website.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Zudem werden anonymisierte Informationen zu Methoden und Trends im Local Storage des Browsers gespeichert, die der Funktionalität der Anwendung dienen (Implementierung eines Warenkorbs zum Download von Informationen). Diese Informationen werden nicht an den Server übertragen und nur lokal auf Ihrem Gerät gespeichert. Eine Identifikation von Personen ist dabei ausgeschlossen.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Die Datenverarbeitungen basieren auf dem überwiegenden berechtigten Interesse an der Gewährleistung der Sicherheit sowie der Funktionsfähigkeit und Funktionalität des Webauftritts gemäß Art. 6 (1) lit f der Datenschutz-Grundverordnung (DSGVO).
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.5rem', sm: '1.7rem', md: '1.9rem' }
                        }}
                    >
                        Löschung der Daten
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Die Serverlogdaten werden so lange verarbeitet, wie es zur Zweckerreichung erforderlich ist, jedoch nicht länger als 90 Tage. Anonymisierte Informationen zu Methoden und Trends werden mit Schließen des Browsers aus dem Browser entfernt.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Die Speicherdauer verlängert sich in allen Fällen um eine etwaige darüber hinausgehend längere Dauer der Anhängigkeit eines gerichtlichen oder behördlichen Verfahrens, in dem die FH CAMPUS 02 Parteistellung hat und diese Daten verfahrensgegenständlich sind.
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.5rem', sm: '1.7rem', md: '1.9rem' }
                        }}
                    >
                        Übermittlungsempfänger*innen
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Ihre Daten werden von uns vertraulich behandelt und grundsätzlich nur durch Mitarbeiter*innen der FH CAMPUS 02 intern verarbeitet. Auch von uns eingesetzte Auftragsverarbeiter können zur Erfüllung der beschriebenen Zwecke Daten für uns verarbeiten, wenn diese hinreichende Garantien für die Sicherheit der Daten bieten.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        So werden die Serverlogdaten im Rahmen des cloudbasierten SIEM-Dienst Azure Sentinel von Microsoft zur Sicherheitsüberwachung und Bedrohungserkennung verarbeitet. Das Hosting erfolgt vorwiegend innerhalb der Europäischen Union entsprechend dem europäischen Datenschutzrecht. Einzelne Dienstleistungen und technischer Support können auch außerhalb der Europäischen Union bereitgestellt werden. Einzelne Daten können daher auch einem Zugriff aus den USA unterliegen.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Die Europäische Kommission hat am 10.07.2023 einen Angemessenheitsbeschluss zum Data Privacy Framework (Datenschutzabkommen zwischen EU und USA) gefasst. Wenn sich Anbieter in den USA gemäß dieser Datenschutzvorgaben (die unter anderem den Datenzugang der US-Behörden beschränken und Rechtsschutz für EU-Bürger*innen einräumen) zertifizieren, wird grundsätzlich ein angemessenes Datenschutzniveau für Datenübermittlungen gewährleistet. Welche Anbieter in der Liste aufgenommen sind, kann hier überprüft werden:{' '}
                        <Typography
                            component="a"
                            href="https://www.dataprivacyframework.gov/s/participant-search"
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{ color: primaryBlue, textDecoration: 'underline' }}
                        >
                            https://www.dataprivacyframework.gov/s/participant-search
                        </Typography>
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        So hat sich Microsoft dieser Selbstzertifizierung unterzogen. Die Datenübermittlung kann daher auf den Angemessenheitsbeschluss zum Data Privacy Framework als gültige Rechtsgrundlage für Datenübermittlungen in die USA gestützt werden. Weiters gelten darüber hinaus die Standardvertragsklauseln und zusätzliche durch Microsoft zugesicherte technisch-organisatorische Maßnahmen. Weitere Informationen zur Datenverarbeitung sind der Datenschutzerklärung von Microsoft  zu entnehmen.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Bitte beachten Sie, dass wir diese Datenschutzerklärung von Zeit zu Zeit aktualisieren (zB. aufgrund von Änderungen gesetzlicher Vorschriften, Einsatz neuer Technologien, neuen Studienangeboten, etc.). Wir empfehlen Ihnen deshalb, diese Datenschutzerklärung regelmäßig auf Neuheiten zu überprüfen.
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Ihnen stehen grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Bitte wenden Sie sich diesbezüglich gerne jederzeit an uns.
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.5rem', sm: '1.7rem', md: '1.9rem' }
                        }}
                    >
                        Kontakt
                    </Typography>
                    <Typography
                        variant="h4"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.5rem' },
                            fontWeight: 'bold'
                        }}
                    >
                        Datenschutz-Koordinationsteam der FH CAMPUS 02
                    </Typography>
                    <Typography variant="body1" paragraph>
                        CAMPUS 02 – Fachhochschule der Wirtschaft GmbH<br />
                        Körblergasse 126, 8010 Graz<br />
                        +43 316 6002-8909<br />
                        E-Mail: datenschutz@campus02.at
                    </Typography>

                    <Typography
                        variant="h4"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.2rem', sm: '1.4rem', md: '1.5rem' },
                            fontWeight: 'bold',
                            mt: 3
                        }}
                    >
                        Datenschutzbeauftragte*r der FH CAMPUS 02
                    </Typography>
                    <Typography variant="body1" paragraph>
                        E-Mail: dsb@campus02.at
                    </Typography>
                </Box>

                <Box sx={contentBoxStyle}>
                    <Typography
                        variant="h3"
                        sx={{
                            color: primaryBlue,
                            mb: { xs: 1, sm: 1.5, md: 2 },
                            fontSize: { xs: '1.5rem', sm: '1.7rem', md: '1.9rem' }
                        }}
                    >
                        Beschwerderecht
                    </Typography>
                    <Typography variant="body1" paragraph className="justified-text">
                        Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich auch bei der Aufsichtsbehörde beschweren. In Österreich ist dies die Datenschutzbehörde:
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Österreichische Datenschutzbehörde<br />
                        Barichgasse 40-42<br />
                        1030 Wien<br />
                        Telefon: +43 1 52 152-0<br />
                        E-Mail: dsb@dsb.gv.at
                    </Typography>

                    <Divider sx={{ my: { xs: 2, sm: 2.5, md: 3 } }} />

                    <Typography variant="body2" sx={{ fontStyle: 'italic' }}>
                        Stand: {new Date().toLocaleDateString('de-AT')}
                    </Typography>
                </Box>
            </Container>

            <Footer />
        </Box>
    );
};

export default Datenschutzerklaerung;